import React, { createContext } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthUser } from "./models/user";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

export const UserContext = createContext<{
  mainUser: AuthUser | null;
  updateUser: (user: AuthUser | null) => void;
} | null>(null);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
